export class Motivo {
    fecha: string;
    texto: string;
    hora: string;
    numeroExpediente: string;
    visita: number;
    episodio: number;
    colegiado: string;
    dniMedico: string;
    numeroMotivo: string;
    seguimiento: string;
    linea: string;
}



// WEBPACK FOOTER //
// ./src/models/motivo.ts